export class Service {
  framework = {};

  init() {}
}
